import { useCallback } from 'react';

import { di } from 'react-magnetic-di';

import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';
import { useUIStore } from '@atlassian/conversation-assistant-store/controllers/ui-store';
import {
	useConversationActionsStore,
	useConversationActionsStoreActions,
} from '@atlassian/rovo-conversation-actions/conversation-actions-store';
import { type ConversationAction } from '@atlassian/rovo-conversation-actions/types';

import { DEFAULT_AGENT } from '../agents/constants';
import { useChatStoreActions } from '../chat-store/main';

export const useActiveAction = (): {
	activeAction: ConversationAction | undefined;
	setActiveAction: (action: ConversationAction | undefined) => void;
} => {
	di(
		useChatStoreActions,
		useConversationActionsStoreActions,
		useConversationActionsStore,
		useUIStore,
	);
	const { setActiveAction_UNSAFE } = useConversationActionsStoreActions();
	const { setSelectedConversation } = useChatStoreActions();
	const { setActiveMenu } = useUIStore();
	const [{ activeAction }] = useConversationActionsStore();

	const setActiveAction = useCallback(
		(action: ConversationAction | undefined): void => {
			setActiveAction_UNSAFE(action);
			if (action) {
				setSelectedConversation({
					conversationId: EMPTY_CONVERSATION_ID,
					sourceAgentId: DEFAULT_AGENT.id,
				});
				setActiveMenu('none');
			}
		},
		[setActiveAction_UNSAFE, setSelectedConversation, setActiveMenu],
	);

	return {
		activeAction,
		setActiveAction,
	};
};
